import { FC, useContext } from 'react';

import { Link } from 'react-router';

import LogoLight from '@/assets/images/logos/light_logo.png';
import LogoDark from '@/assets/images/logos/dark_logo.png';
import { styled } from '@mui/material';
import config from '@/context/config';
import { CustomizerContext } from '@/context/CustomizerContext';

interface LogoProps {
  forDarkBackground?: boolean;
}

const Logo: FC<LogoProps> = ({ forDarkBackground = false }) => {
  const { isCollapse, isSidebarHover, activeMode } =
    useContext(CustomizerContext);
  const TopbarHeight = config.topbarHeight;

  const LinkStyled = styled(Link)(() => ({
    height: TopbarHeight,
    width: isCollapse === 'mini-sidebar' && !isSidebarHover ? '40px' : '180px',
    overflow: 'hidden',
    display: 'block',
  }));

  const logoSrc = forDarkBackground || activeMode === 'dark'
    ? LogoLight
    : LogoDark;

  return (
    <LinkStyled
      to="/dashboard"
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <img src={logoSrc} style={{ width: '100%' }} alt="Chip Tuning LLC" />
    </LinkStyled>
  );
};

export default Logo;
